module.exports = __webpack_public_path__ + "static/media/login-background.1c55cad8.png";